module.exports = __webpack_public_path__ + "static/media/ModalLayout.cd1532b6.less";


//////////////////
// WEBPACK FOOTER
// ./node_modules/slide-new-toolkit/dist/layouts/ModalLayout.less
// module id = 1042
// module chunks = 0